module.exports = __webpack_public_path__ + "static/media/Text.8b46bf92.svg";